module.exports = __webpack_public_path__ + "public/SiteIcons/information-button.svg?6a932828";